import { TextValue } from '@shared/interfaces';
import { SortOrderEnum } from '@shared/enums';

export const tablePageSizeOptions: number[] = [15, 25, 50, 100];

export const sortOrderOptions: TextValue[] = [
    { text: 'ascending', value: SortOrderEnum.ASC },
    { text: 'descending', value: SortOrderEnum.DESC },
];
